<template lang='pug'>
	.privacy-policy(id='home')
		v-e24-nav-bar
		headerResources(:srcImage='img', :tall="tall", h1="What if I encounter a problem ?")
		contentFaq
		v-e24-footer(:build="build")
</template>
<script>
import headerResources from '@/commonSite/header.vue'
import contentFaq from '@/components/resources/content-faq-d.vue'
import imageHeader from '@/img/faq-header.jpg'
import readBuild from '../../util/readBuild'

export default {
	name: 'faqD',
	components: {
		headerResources,
		contentFaq
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/faqs/FaqD.vue